import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackToggledContentCollectionFormAutoSubmitOn.meta';

export type TrackToggledContentCollectionFormAutoSubmitOnParams = {
  form_id: string;
};

export const useTrackToggledContentCollectionFormAutoSubmitOn = () => {
  const { track } = useAnalyticsUtilities();

  const trackToggledContentCollectionFormAutoSubmitOn = useCallback(
    (params: TrackToggledContentCollectionFormAutoSubmitOnParams) => {
      track(META.name, params);
    },
    [track],
  );

  return {
    trackToggledContentCollectionFormAutoSubmitOn,
  };
};
